import type { FC } from 'react';

export const NextArrowIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      className={className}
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z"
        fill="#6A73B5"
      />
      <path
        d="M19.125 18.3033L15 14.1783L16.1783 13L21.4817 18.3033L16.1783 23.6066L15 22.4283L19.125 18.3033Z"
        fill="white"
      />
    </svg>
  );
};
